"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");

var ReleaseItemRepricing =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ReleaseItemRepricing, _DomainObject_1$Domai);

  /**
   * @param possible True if repricing is possible. In that case the possibleFrom has to be defined.
   * @param possibleFrom New price validity start. Has to be filled if repricing is possible,
   * because it is expected by Pricing Frequency constraint.
   * @param validationResult Messages which carry information why the repricing is not possible or why is postponed.
   */
  function ReleaseItemRepricing(possible, possibleFrom, validationResult) {
    var _this;

    _classCallCheck(this, ReleaseItemRepricing);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseItemRepricing).call(this));
    _this.possible = possible;
    _this.possibleFrom = possibleFrom;
    _this.validationResult = validationResult;
    return _this;
  }

  _createClass(ReleaseItemRepricing, [{
    key: "withMessage",
    value: function withMessage(message) {
      return this.copy('validationResult', this.validationResult.addObjectIfNotPresent(message));
    }
  }, {
    key: "equals",
    value: function equals(other) {
      var pOK = this.possible === other.possible;
      var pfOk = this.possibleFrom === other.possibleFrom || this.possibleFrom != null && other.possibleFrom != null && this.possibleFrom.valueOf() === other.possibleFrom.valueOf();
      var rOK = this.validationResult.resultObjects.equals(other.validationResult.resultObjects);
      return pOK && pfOk && rOK;
    }
  }], [{
    key: "aggregate",
    value: function aggregate(repricings) {
      var possible = true;
      var possibleFrom = repricings.length !== 0 ? repricings[0].possibleFrom : null;
      var messages = ValidationResult_1.ValidationResult.EMPTY;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = repricings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var repr = _step.value;
          possible = possible && repr.possible;

          if (repr.possibleFrom != null && possibleFrom !== null && possibleFrom.isBefore(repr.possibleFrom)) {
            possibleFrom = repr.possibleFrom;
          }

          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = repr.validationResult.resultObjects[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var reas = _step2.value;
              // We expects that the list will be typically very short...
              messages = messages.addObjectIfNotPresent(reas);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return new ReleaseItemRepricing(possible, possibleFrom, messages);
    }
  }]);

  return ReleaseItemRepricing;
}(DomainObject_1.DomainObject);

exports.ReleaseItemRepricing = ReleaseItemRepricing;
/**
 * Initial value for repricing possibility, it can be changed after application of constraints.
 */

ReleaseItemRepricing.INITIAL = new ReleaseItemRepricing(true, null, ValidationResult_1.ValidationResult.EMPTY);

ReleaseItemRepricing.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ReleaseItemRepricing.name);
  return {
    possible: builder.bool('possible'),
    possibleFrom: builder.opt(builder.date('possibleFrom', DateParser_1.DateParser.ISO_PATTERN)),
    validationResult: builder.obj('validationResult', ValidationResult_1.ValidationResult.schema, function (mat) {
      return new ValidationResult_1.ValidationResult(mat.resultObjects);
    })
  };
}();